import { SysApi } from '/@/api/sys/system';
import { fetchEventSource } from '@microsoft/fetch-event-source';
import { AUTH_PREFIX } from '/@/api/const';
import { useUserStore } from '/@/store/modules/user';
import { useAppStore } from '/@/store/modules/app';
import { watch } from 'vue';
import { getApiUrlByDomain } from '/@/utils/http/axios';

const notifyEventList = ['NEW_INFO', 'NEW_EXPORT_FILE'];
export async function useNotification() {
  const appStore = useAppStore();
  const userStore = useUserStore();
  const controller = new AbortController();
  const signal = controller.signal;
  function subscribeFn() {
    appStore.queryNewNotifyList();
    const url = getApiUrlByDomain(window.location.href) + SysApi.subscribe;
    fetchEventSource(url, {
      signal,
      openWhenHidden: true,
      headers: {
        Authorization: AUTH_PREFIX + userStore.getToken,
      },
      onmessage: (event) => {
        console.log('EventSource', event);
        if (notifyEventList.includes(event.data)) {
          appStore.queryNewNotifyList();
        }
      },
      onerror(err) {
        console.log('EventSource error', err);
      },
    });
  }
  watch(
    () => appStore.getNotificationIsShow,
    (isSub, oldSub) => {
      if (isSub) {
        subscribeFn();
      }
      if (!isSub && oldSub) {
        controller.abort();
      }
    },
    {
      immediate: true,
    },
  );
}
